import {
  IHrDepartment,
  IHrDepartmentData,
  IHrDepartmentFieldError,
  IHrDepartmentFieldErrorData
} from './hr-department.types';

export class HrDepartment implements IHrDepartment {
  readonly id?: number;
  readonly name: string;
  readonly code: number | null = null;

  constructor(data: IHrDepartmentData) {
    if (data.id) {
      this.id = data.id;
    }
    this.name = data.name;
    if (data.code) {
      this.code = data.code;
    }
  }

  validate(): boolean {
    if (this.name) {
      return true;
    } else {
      return false;
    }
  }

  toString(): string {
    let stringRepresentation = this.name ?? '';
    if (this.code) {
      stringRepresentation = `${this.code} - ${stringRepresentation}`;
    }

    return stringRepresentation.trim();
  }
}

export class HrDepartmentFieldError implements IHrDepartmentFieldError {
  readonly name: string[] = [];

  constructor(data?: IHrDepartmentFieldErrorData) {
    if (data) {
      if (data.name) {
        this.name = data.name;
      }
    }
  }

  clearErrors(): void {
    this.name.splice(0, this.name.length);
  }

  static isHrDepartmentFieldError(data: IHrDepartmentFieldErrorData): boolean {
    if (data.name && Array.isArray(data.name)) {
      return true;
    }
    return false;
  }
}
